import React, {useContext, useEffect, useState} from 'react';
import {Card, CardContent, Grid} from "@mui/material";
import {blueColor} from "../../../../assets/jss/main";
import {FormattedMessage} from "react-intl";
import MissionResumeItem from "../../../../components/WMS/MissionResumeItem";
import {getDashboardWmsItemsCount} from "api/wms/wmsItems/wmsItems";
import {getDashboardWmsItemsStatus, WmsItemsStatus} from "../../../../utils/WmsItemsStatus";
import {WMSContext} from "../../context/WMSContext";

function MissionResume() {
    const {currentInventory} = useContext(WMSContext)

    const [wmsItemsCount, setWmsItemsCount] = useState([])
    const [pendingItemsCount, setPendingItemsCount] = useState(0)
    const [readyToSortItemCount, setReadyToSortItemCount] = useState(0)
    const [readyToPackItemCount, setReadyToPackItemCount] = useState(0)
    const [readyToShipItemCount, setReadyToShipItemCount] = useState(0)

    const [shipmentCount, setShipmentCount] = useState([]);
    const [triShippingCount, setTriShippingCount] = useState(0);
    const [receptionCCCount, setReceptionCCCount] = useState(0);
    const [ccHandOverCount, setCcHandOverCount] = useState(0);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (currentInventory) {
            setLoading(true)

            getDashboardWmsItemsCount(currentInventory.id, getDashboardWmsItemsStatus()).then((response) => {
                setWmsItemsCount(response.wmsItemsCount);
                setShipmentCount(response.shipmentsCount);
            }).finally(() => setLoading(false));
        }
    }, [currentInventory]);

    useEffect(() => {
        wmsItemsCount.forEach((item) => {
            switch (item.status) {
                case WmsItemsStatus.PENDING:
                    setPendingItemsCount(item.count ?? 0)
                    break;
                case WmsItemsStatus.READY_TO_BE_SORTED:
                    setReadyToSortItemCount(item.count ?? 0)
                    break;
                case WmsItemsStatus.READY_TO_BE_PACKED:
                    setReadyToPackItemCount(item.count ?? 0)
                    break;
                case WmsItemsStatus.READY_TO_BE_SHIPPED:
                    setReadyToShipItemCount(item.count ?? 0)
                    break;
                default:
                    break;
            }
        })
    }, [wmsItemsCount]);

    useEffect(() => {
        shipmentCount.forEach((shipment) => {
            switch (shipment.status) {
                case 'to_sort':
                    setTriShippingCount(shipment.count ?? 0);
                    break;
                case 'reception_cc':
                    setReceptionCCCount(shipment.count ?? 0)
                    break;
                case 'cc_hand_over':
                    setCcHandOverCount(shipment.count ?? 0)
                    break;
                default:
                    break;
            }
        })
    }, [shipmentCount]);

    return (
        <Card sx={{
            marginBottom: '32px',
            boxShadow: 0
        }}>
            <CardContent>
                <div style={{
                    color: blueColor,
                    fontSize: '16px',
                    fontWeight: 600,
                    marginBottom: '32px'
                }}>
                    <FormattedMessage id={"wms.missionResume.title"}/>
                </div>
                <Grid container direction={'column'}>
                    <Grid>
                        <MissionResumeItem
                            count={pendingItemsCount}
                            text={<FormattedMessage id={"wms.missionResume.pickProduct"} />}
                            type={"pickup"}
                            loading={loading}
                        />
                    </Grid>
                    <Grid>
                        <MissionResumeItem
                            count={readyToSortItemCount}
                            text={<FormattedMessage id={"wms.missionResume.sortProduct"} />}
                            type={"sort"}
                            loading={loading}
                        />
                    </Grid>
                    <Grid>
                        <MissionResumeItem
                            count={readyToPackItemCount}
                            text={<FormattedMessage id={"wms.missionResume.packProduct"} />}
                            type={"pack"}
                            loading={loading}
                        />
                    </Grid>
                    <Grid>
                        <MissionResumeItem
                            count={triShippingCount}
                            text={<FormattedMessage id={"wms.missionResume.tri_shipping"} />}
                            type={'tri_shipping'}
                            loading={loading}
                        />
                    </Grid>
                    <Grid>
                        <MissionResumeItem
                            count={receptionCCCount}
                            text={<FormattedMessage id={"wms.missionResume.reception_cc"} />}
                            type={'reception_cc'}
                            loading={loading}
                        />
                    </Grid>
                    <Grid>
                        <MissionResumeItem
                            count={ccHandOverCount}
                            text={<FormattedMessage id={"wms.missionResume.cc_hand_over"} />}
                            type={'cc_hand_over'}
                            loading={loading}
                        />
                    </Grid>
                    <Grid>
                        <MissionResumeItem
                            count={readyToShipItemCount}
                            text={<FormattedMessage id={"wms.missionResume.shipProduct"} />}
                            type={"ship"}
                            loading={loading}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default MissionResume;
